export default __webpack_public_path__ + "static/media/block.cef22957.svg";